module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Light.c41494a.woff2";